import * as ambassadorWixMembersV1CustomField from './members-v1-custom-field-custom-fields.http.js';
import * as ambassadorWixMembersV1CustomFieldTypes from './members-v1-custom-field-custom-fields.types.js';
import * as ambassadorWixMembersV1CustomFieldUniversalTypes from './members-v1-custom-field-custom-fields.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createCustomField(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1CustomFieldUniversalTypes.CreateCustomFieldRequest,
  ambassadorWixMembersV1CustomFieldTypes.CreateCustomFieldRequest,
  ambassadorWixMembersV1CustomFieldUniversalTypes.CreateCustomFieldResponse,
  ambassadorWixMembersV1CustomFieldTypes.CreateCustomFieldResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomField.createCustomField(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/custom-fields',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCustomField(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixMembersV1CustomFieldUniversalTypes.GetCustomFieldRequest,
  ambassadorWixMembersV1CustomFieldTypes.GetCustomFieldRequest,
  ambassadorWixMembersV1CustomFieldUniversalTypes.GetCustomFieldResponse,
  ambassadorWixMembersV1CustomFieldTypes.GetCustomFieldResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomField.getCustomField(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/custom-fields/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listCustomFields(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixMembersV1CustomFieldUniversalTypes.ListCustomFieldsRequest,
  ambassadorWixMembersV1CustomFieldTypes.ListCustomFieldsRequest,
  ambassadorWixMembersV1CustomFieldUniversalTypes.ListCustomFieldsResponse,
  ambassadorWixMembersV1CustomFieldTypes.ListCustomFieldsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomField.listCustomFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/custom-fields',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCustomField(): __PublicMethodMetaInfo<
  'PATCH',
  { fieldId: string },
  ambassadorWixMembersV1CustomFieldUniversalTypes.UpdateCustomFieldRequest,
  ambassadorWixMembersV1CustomFieldTypes.UpdateCustomFieldRequest,
  ambassadorWixMembersV1CustomFieldUniversalTypes.UpdateCustomFieldResponse,
  ambassadorWixMembersV1CustomFieldTypes.UpdateCustomFieldResponse
> {
  const payload = { field: { id: ':fieldId' } } as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomField.updateCustomField(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/custom-fields/{field.id}',
    pathParams: { fieldId: 'fieldId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCustomField(): __PublicMethodMetaInfo<
  'DELETE',
  { id: string },
  ambassadorWixMembersV1CustomFieldUniversalTypes.DeleteCustomFieldRequest,
  ambassadorWixMembersV1CustomFieldTypes.DeleteCustomFieldRequest,
  ambassadorWixMembersV1CustomFieldUniversalTypes.DeleteCustomFieldResponse,
  ambassadorWixMembersV1CustomFieldTypes.DeleteCustomFieldResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomField.deleteCustomField(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/custom-fields/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function hideCustomField(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixMembersV1CustomFieldUniversalTypes.HideCustomFieldRequest,
  ambassadorWixMembersV1CustomFieldTypes.HideCustomFieldRequest,
  ambassadorWixMembersV1CustomFieldUniversalTypes.HideCustomFieldResponse,
  ambassadorWixMembersV1CustomFieldTypes.HideCustomFieldResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomField.hideCustomField(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/custom-fields/{id}/hide',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCustomFieldsOrder(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixMembersV1CustomFieldUniversalTypes.UpdateCustomFieldsOrderRequest,
  ambassadorWixMembersV1CustomFieldTypes.UpdateCustomFieldsOrderRequest,
  ambassadorWixMembersV1CustomFieldUniversalTypes.UpdateCustomFieldsOrderResponse,
  ambassadorWixMembersV1CustomFieldTypes.UpdateCustomFieldsOrderResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixMembersV1CustomField.updateCustomFieldsOrder(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/custom-fields/order',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  CustomField as CustomFieldOriginal,
  Privacy as PrivacyOriginal,
  PrivacyWithLiterals as PrivacyWithLiteralsOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  SocialTypeType as SocialTypeTypeOriginal,
  SocialTypeTypeWithLiterals as SocialTypeTypeWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  AppliesTo as AppliesToOriginal,
  AppliesToWithLiterals as AppliesToWithLiteralsOriginal,
  Section as SectionOriginal,
  SectionWithLiterals as SectionWithLiteralsOriginal,
  CreateCustomFieldRequest as CreateCustomFieldRequestOriginal,
  CreateCustomFieldResponse as CreateCustomFieldResponseOriginal,
  IncorrectFieldTypeData as IncorrectFieldTypeDataOriginal,
  IncorrectPrivacyData as IncorrectPrivacyDataOriginal,
  InvalidSocialTypeData as InvalidSocialTypeDataOriginal,
  GetCustomFieldRequest as GetCustomFieldRequestOriginal,
  GetCustomFieldResponse as GetCustomFieldResponseOriginal,
  ListCustomFieldsRequest as ListCustomFieldsRequestOriginal,
  Paging as PagingOriginal,
  ListCustomFieldsResponse as ListCustomFieldsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  UpdateCustomFieldRequest as UpdateCustomFieldRequestOriginal,
  UpdateCustomFieldResponse as UpdateCustomFieldResponseOriginal,
  DefaultPrivacyChanged as DefaultPrivacyChangedOriginal,
  ReservedFieldNameNonEditable as ReservedFieldNameNonEditableOriginal,
  DeleteCustomFieldRequest as DeleteCustomFieldRequestOriginal,
  DeleteCustomFieldResponse as DeleteCustomFieldResponseOriginal,
  HideCustomFieldRequest as HideCustomFieldRequestOriginal,
  HideCustomFieldResponse as HideCustomFieldResponseOriginal,
  UpdateCustomFieldsOrderRequest as UpdateCustomFieldsOrderRequestOriginal,
  UpdateCustomFieldsOrderResponse as UpdateCustomFieldsOrderResponseOriginal,
  MetaSiteSpecialEvent as MetaSiteSpecialEventOriginal,
  MetaSiteSpecialEventPayloadOneOf as MetaSiteSpecialEventPayloadOneOfOriginal,
  Asset as AssetOriginal,
  State as StateOriginal,
  StateWithLiterals as StateWithLiteralsOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCreatedContext as SiteCreatedContextOriginal,
  SiteCreatedContextWithLiterals as SiteCreatedContextWithLiteralsOriginal,
  Namespace as NamespaceOriginal,
  NamespaceWithLiterals as NamespaceWithLiteralsOriginal,
  SiteTransferred as SiteTransferredOriginal,
  SiteDeleted as SiteDeletedOriginal,
  DeleteContext as DeleteContextOriginal,
  DeleteStatus as DeleteStatusOriginal,
  DeleteStatusWithLiterals as DeleteStatusWithLiteralsOriginal,
  SiteUndeleted as SiteUndeletedOriginal,
  SitePublished as SitePublishedOriginal,
  SiteUnpublished as SiteUnpublishedOriginal,
  SiteMarkedAsTemplate as SiteMarkedAsTemplateOriginal,
  SiteMarkedAsWixSite as SiteMarkedAsWixSiteOriginal,
  ServiceProvisioned as ServiceProvisionedOriginal,
  ServiceRemoved as ServiceRemovedOriginal,
  SiteRenamed as SiteRenamedOriginal,
  SiteHardDeleted as SiteHardDeletedOriginal,
  NamespaceChanged as NamespaceChangedOriginal,
  StudioAssigned as StudioAssignedOriginal,
  StudioUnassigned as StudioUnassignedOriginal,
  SiteUrlChanged as SiteUrlChangedOriginal,
  SitePurgedExternally as SitePurgedExternallyOriginal,
  OdeditorAssigned as OdeditorAssignedOriginal,
  OdeditorUnassigned as OdeditorUnassignedOriginal,
  PicassoAssigned as PicassoAssignedOriginal,
  PicassoUnassigned as PicassoUnassignedOriginal,
  WixelAssigned as WixelAssignedOriginal,
  WixelUnassigned as WixelUnassignedOriginal,
  StudioTwoAssigned as StudioTwoAssignedOriginal,
  StudioTwoUnassigned as StudioTwoUnassignedOriginal,
  UserDomainMediaEnabled as UserDomainMediaEnabledOriginal,
  UserDomainMediaDisabled as UserDomainMediaDisabledOriginal,
  EditorlessAssigned as EditorlessAssignedOriginal,
  EditorlessUnassigned as EditorlessUnassignedOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateCustomFieldApplicationErrors as CreateCustomFieldApplicationErrorsOriginal,
  UpdateCustomFieldApplicationErrors as UpdateCustomFieldApplicationErrorsOriginal,
} from './members-v1-custom-field-custom-fields.types.js';
